import styled from 'styled-components'

export const TextWithIcon = styled.div`
  background-color: #ffff;
  display: flex;
  margin: 0;
  margin-top: 2px;
  padding: 2px 10px;
`

export const TextWithoutIcon = styled.div`
  margin-left: 50px;
`
